export default "__VITE_ASSET__ZXeUMiGk__"